import React from "react";
import { Skeleton } from "@mui/material";
import Grid from '@mui/material/Grid2';

const AdminDashSkeleton = () => {

    return (
        <>
            <Grid item size={{xs:6,sm:6,md:3,lg:3}}>
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    animation="wave"
                    height={140}
                    style={{borderRadius:16,marginBottom:5}}
                />
            </Grid>
            <Grid item size={{xs:6,sm:6,md:3,lg:3}}>
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    animation="wave"
                    height={140}
                    style={{borderRadius:16,marginBottom:5}}
                />
            </Grid>
            <Grid item size={{xs:6,sm:6,md:3,lg:3}}>
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    animation="wave"
                    height={140}
                    style={{borderRadius:16,marginBottom:5}}
                />
            </Grid>
            <Grid item size={{xs:6,sm:6,md:3,lg:3}}>
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    animation="wave"
                    height={140}
                    style={{borderRadius:16,marginBottom:5}}
                />
            </Grid>

            <Grid item size={{xs:12,md:6}}>
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={300}
                    animation="wave"
                    style={{borderRadius:16,marginBottom:5}}
                />
            </Grid>
            <Grid item size={{xs:12,md:6}}>
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={300}
                    animation="wave"
                    style={{borderRadius:16,marginBottom:5}}
                />
            </Grid>

            <Grid item size={{xs:12,md:6}}>
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={300}
                    animation="wave"
                    style={{borderRadius:16,marginBottom:10}}
                />
            </Grid>
            <Grid item size={{xs:12,md:6}}>
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={300}
                    animation="wave"
                    style={{borderRadius:16,marginBottom:10}}
                />
            </Grid>
        </>

    );
};

export default AdminDashSkeleton;
